import React from 'react'

const Hero = () => {
  return (
    // Hero Image
    <section className="hero">
      <h2>Frank Lavery:  Portfolio of Work</h2>
    </section >
  )
}

export default Hero